import * as React from "react";
import { Path, G, ClipPath, Defs, Rect } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const THIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="TH" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#F50101"
        fillRule="evenodd"
        d="M0 8h16v4H0V8ZM0 0h16v3H0V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#3D58DB"
        stroke="#fff"
        strokeWidth={1.5}
        d="M16.75 3.25v5.5H-.75v-5.5h17.5Z"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
